import { Link } from "react-router-dom";
import { useTranslation } from "@mywheels/common/lib/translation";

import { LinkArrow, Markdown } from "web/ui";
import { useLangPrefixify } from "web/lib/i18n";

import { _blogPicture } from "./styles";
import { PostMeta } from "./PostMeta";
import { BlogPostSearchResult, blogPostUrl } from "./data";

export function BlogCard({ post }: { post: BlogPostSearchResult }) {
  const { t } = useTranslation();
  const lp = useLangPrefixify();

  return (
    <div className="mb-5">
      {post.featuredImage && (
        <Link
          className={_blogPicture}
          style={{
            backgroundImage: `url("https://media.graphcms.com/output=format:jpg/resize=,height:800,fit:max/${post.featuredImage.handle}")`,
          }}
          to={lp(blogPostUrl(post))}
        />
      )}
      <div className="mt-5">
        <div className="mb-3">
          <Link
            to={lp(blogPostUrl(post))}
            style={{ textDecoration: "none", color: "#222" }}
          >
            <p className="font-display text-xl mb-0">{post.title}</p>
          </Link>
          <PostMeta post={post} />
        </div>
        <div className="text-muted">
          <Markdown
            source={post.excerpt || ""}
            inline={false}
            className="prose"
          />
        </div>
        <p>
          <Link
            className="text-gray hover:text-gray700 underline font-display"
            to={lp(blogPostUrl(post))}
          >
            {t("Lees meer")}
            <LinkArrow />
          </Link>
        </p>
      </div>
    </div>
  );
}
